import { Injectable } from '@angular/core';
import { Observable, distinctUntilChanged, map } from 'rxjs';
import { Stop } from '../../shared/models/stop';
import { Store } from './store.model';
import { ActivityPoint } from '../../shared/models';

export interface StopStoreState {
    selectedStops: Stop[] | ActivityPoint[];
}

@Injectable({
    providedIn: 'root'
})
export class StopStore extends Store<StopStoreState> {
    constructor() {
        super({
            selectedStops: undefined
        });
    }

    public getSelectedStopState(): Observable<Stop[] | ActivityPoint[]> {
        return super.state$.pipe(
            map(state => state.selectedStops),
            distinctUntilChanged() 
        );
    }

    public setSelected(selectedStops: Stop[] | ActivityPoint[]) {
        this.setState({
            ...this.stateSnapshot,
            selectedStops
        });
    }

    public clearSelected() {
        this.setState({
            ...this.stateSnapshot,
            selectedStops: undefined
        });
    }
}